import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractField } from './abstract-field.component';

const customValueProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CvvFieldComponent),
  multi: true
};

@Component({
  selector: 'cvv-field',
  inputs: [...AbstractField.inputs],
  outputs: [...AbstractField.outputs],
  template: `
    <div
      [floatingLabel]="model"
      [focus]="focused"
      [ngClass]="{
        'validation-failed':
          (showValidation || inp.dirty || inp.touched) &&
          required &&
          (!model || model == '' || !inp.valid)
      }"
    >
      <label for="FIELD={{ id }}">{{ label + (required ? '*' : '') }}</label>
      <input
        [autocomplete]="autocomplete"
        [attr.name]="autocomplete"
        id="FIELD-{{ id }}"
        [(ngModel)]="model"
        [placeholder]="label + (required ? ' *' : '')"
        class="form-control"
        (focus)="focused = true"
        (blur)="onBlur($event)"
        (ngModelChange)="onChange($event)"
        [disabled]="disabled"
        [required]="required"
        #inp="ngModel"
        type="tel"
      />
    </div>
  `,
  providers: [customValueProvider]
})
export class CvvFieldComponent extends AbstractField {
  constructor() {
    super();
  }
}
